// The BRIEF step (prototype stepBody 'brief'): the drafted workflow's name and the owner's ask, in
// their own words, plus the one "Draft the configuration" action that starts the staged reveal. The
// console is a REVIEW surface — both fields render read-only from the projection (G-182; there is no
// composer write seam this build, so an editable field would be dishonest). The Draft button is this
// view's ONE primary action (house rule); the step foot's continue control stays ghost here.

import { FieldLabel, PRIMARY_BUTTON_CLASS } from '../composer-ui.tsx';

export interface BriefStepProps {
  readonly workflowName: string;
  readonly ownerAsk: string;
  readonly onDraft: () => void;
}

/** The owner's-ask step. */
export function BriefStep({ workflowName, ownerAsk, onDraft }: BriefStepProps): React.JSX.Element {
  return (
    <div className="max-w-2xl">
      <FieldLabel htmlFor="composer-workflow-name">Workflow name</FieldLabel>
      <input
        id="composer-workflow-name"
        readOnly
        value={workflowName}
        className="ritona-voice mt-2 w-full rounded-md border border-border bg-surface px-4 py-3 text-lg text-text"
      />
      <div className="mt-5">
        <FieldLabel>Describe the job — in the owner’s words</FieldLabel>
      </div>
      <blockquote
        data-owner-ask="true"
        className="ritona-voice mt-2 rounded-md border border-border border-l-2 border-l-sage bg-surface-sunken px-5 py-4 text-lg leading-relaxed text-text"
      >
        {ownerAsk}
      </blockquote>
      <div className="mt-6 flex items-center gap-4">
        <button type="button" onClick={onDraft} className={PRIMARY_BUTTON_CLASS}>
          Draft the configuration
        </button>
        <span className="max-w-prose text-xs leading-relaxed text-text-subtle">
          Ritona assembles skill, pulls, lifecycle and palette from this brief. You review each
          before it can run.
        </span>
      </div>
    </div>
  );
}
